import { Languages } from 'lucide-react'
import { useI18n, type Locale } from '@/lib/i18n'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

const LOCALE_LABELS: Record<Locale, { native: string; english: string }> = {
  en: { native: 'English', english: 'English' },
  ur: { native: 'اردو', english: 'Urdu' },
  ar: { native: 'العربية', english: 'Arabic' },
}

export function LocaleSwitcher() {
  const { locale, setLocale } = useI18n()
  const current = LOCALE_LABELS[locale]

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" title={`Language: ${current.english}`} aria-label="Change language">
          <Languages className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {(Object.keys(LOCALE_LABELS) as Locale[]).map((code) => (
          <DropdownMenuItem key={code} onClick={() => setLocale(code)}>
            <span className="flex w-full items-center justify-between gap-3">
              <span>{LOCALE_LABELS[code].native}</span>
              <span className="text-xs text-muted-foreground">{LOCALE_LABELS[code].english}</span>
              {code === locale && <span className="text-accent">✓</span>}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
